<template>
  <div>
    <section class="content">
      <div
        class="pull-right btn-information col-xs-2"
        v-show="isAdmin"
      >
        <button
          class="btn btn-info btn-information-save"
          v-on:click="handleUpgrade"
        >Upgrade</button>
      </div>

      <section class="content">
        <div class="information-content">
          <div class="form-group" v-show="isAdmin">
            <label>APP ID</label>
            <input
              type="text"
              class="form-control"
              placeholder="Text"
              v-model="$route.query.appid"
              disabled
            >
          </div>
          <div class="form-group" v-show="isAdmin">
            <label>Device ID</label>
            <input
              type="text"
              class="form-control"
              placeholder="Text"
              v-model="$route.query.deviceid"
              disabled
            >
          </div>
          <div class="form-group">
            <label>URL</label>
            <input
              type="text"
              :disabled="!isAdmin"
              name="url"
              class="form-control"
              placeholder="url"
              v-model="formData.url"
            >
          </div>
          <div class="form-group">
            <label>Upper MD5</label>
            <input
              type="text"
              :disabled="!isAdmin"
              name="uppermd5"
              class="form-control"
              placeholder="uppermd5"
              v-model="formData.uppermd5"
            >
          </div>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import utils from "../../utils";
import api from '../../api';

export default {
  name: "DeviceUpgrade",
  data() {
    return {
      formData: {
        url: "",
        uppermd5: "",
      },
      isAdmin: utils.checkIsAdmin()
    };
  },
  methods: {
    async handleUpgrade() {
      const { appid, deviceid } = this.$route.query;
      const { url } = this.formData;
      if (!utils.checkIsURL(url)) {
        return alert(`"${url}" is not a valid url`);
      }

      let data = {
        ...this.formData,
        deviceid,
      }
      let res = await api.post_blackhole({
        path: "/device/sendcmdadmin",
        cmd: "SYSTEM_UPDATEVERSION",
        withLoading: true,
        appid,
        data,
      });
      console.log("send result", res);
      alert("OK");
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// DeviceUpgrade.vue?7941e830